import React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "../../lib/utils";

interface MobileSelectFieldProps {
  value: string;
  options: { label: string; value: string }[];
  placeholder?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

/** Uses the platform picker (iOS wheel / Android dialog) for a native feel. */
const MobileSelectField: React.FC<MobileSelectFieldProps> = ({
  value,
  options,
  placeholder,
  onChange,
  disabled,
  className,
}) => {
  const validOptions = options.filter((option) => option.value != null && option.value !== "");
  const hasValue = validOptions.some((option) => option.value === value);

  return (
    <div className={cn("relative w-full", className)}>
      <select
        value={hasValue ? value : ""}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
        className={cn(
          "h-11 w-full appearance-none rounded-xl border-0 bg-white pl-3.5 pr-10 text-[15px] shadow-[0_1px_2px_rgba(13,14,19,0.04)] ring-1 ring-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:opacity-50",
          hasValue ? "text-gray-900" : "text-gray-400",
        )}
      >
        {!hasValue && (
          <option value="" disabled>
            {placeholder ?? "Select"}
          </option>
        )}
        {validOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
    </div>
  );
};

export default MobileSelectField;
